import { FulfillmentOptionsCardProp } from '@springbig/shared';
import React from 'react';
import { Button, FlatList } from 'native-base';
import { useShopStyles } from '~/shared/styles';
import { Caption } from '~/shared/Typography';

export type FulfillmentOptionsProps = {
    setFullfillmentOption: (value: FulfillmentOptionsCardProp) => void;
    fullfillmentOptions: Array<FulfillmentOptionsCardProp>;
};

export const FullfillmentOptions = ({
    setFullfillmentOption,
    fullfillmentOptions,
}:  FulfillmentOptionsProps) => {

    const { pressable_text, section_background } = useShopStyles();

    return (
        <FlatList
            rounded={'md'}
            bg={section_background}
            data={fullfillmentOptions}
            renderItem={({ item }: { item: FulfillmentOptionsCardProp }) =>

                <Button onPress={item.isOpen === undefined || item.isOpen ? () => setFullfillmentOption(item) : null}>
                    <Caption color={item.isOpen === undefined || item.isOpen ? pressable_text : 'gray'}>
                        { item.label }
                    </Caption>
                </Button>
            }
        />
    );
};
